export const TXTCLI_Password_may_not_start_with_th_ELL = {
  "id": "TXTCLI_Password_may_not_start_with_th_ELL",
  "defaultMessage": "Password may not start with the letters ''tmp''"
} as const;